/**
 * Dialogs container for the app layout.
 * Handles create organization and delete conversation dialogs.
 */
import type { ReactNode } from 'react'

import { ConfirmDialog } from '@/components/molecules/confirm-dialog.molecule'
import { CreateOrganizationDialog } from '@/components/org-settings/create-organization-dialog.organism'
import type { CreateOrganizationFormData } from '@/components/org-settings/org-settings.interface'

import type { ChatDeleteDialogState } from './use-app-layout-actions.hook'
import type { CreateOrganizationDialogState } from './use-app-layout-organization.hook'

interface AppLayoutDialogsProps {
  createOrgDialog: CreateOrganizationDialogState
  chatDeleteDialog: ChatDeleteDialogState
  onCreateOrgDialogChange: (isOpen: boolean) => void
  onCreateOrgSubmit: (data: CreateOrganizationFormData) => void
}

export const AppLayoutDialogs = ({
  createOrgDialog,
  chatDeleteDialog,
  onCreateOrgDialogChange,
  onCreateOrgSubmit,
}: AppLayoutDialogsProps): ReactNode => (
  <>
    <CreateOrganizationDialog
      isOpen={createOrgDialog.isOpen}
      onOpenChange={onCreateOrgDialogChange}
      onSubmit={onCreateOrgSubmit}
      isLoading={createOrgDialog.isLoading}
    />
    <ConfirmDialog
      isOpen={chatDeleteDialog.deletingConversationId !== null}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          chatDeleteDialog.onCancel()
        }
      }}
      title="Delete Conversation"
      description="Are you sure you want to delete this conversation? This action cannot be undone."
      confirmLabel="Delete"
      cancelLabel="Cancel"
      onConfirm={chatDeleteDialog.onConfirm}
      onCancel={chatDeleteDialog.onCancel}
      variant="destructive"
    />
  </>
)
